import * as Yup from 'yup';

export const ReportIssueSchema = Yup.object().shape({
  issueType: Yup.string().required('Issue type is required'),
});

export interface ReportIssueDataType {
  issueType: string;
}

export const ReportIssueInitialValues: ReportIssueDataType = {
  issueType: '',
};

export interface ReportIssueInterface {
  issueType: string;
}
